import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';

import Field from '@/../bower_components/teknisavuecomponents/assets/interfaces/Field';
import TkForm from '@/../bower_components/teknisavuecomponents/components/TkForm.vue';
import EditableTable from '@/../bower_components/teknisavuecomponents/components/grids/EditableTable.vue';
import Util from '@/../bower_components/teknisavuecomponents/assets/utils/Util';

import EditableTableColumn from '@/../bower_components/teknisavuecomponents/assets/interfaces/EditableTableColumn';
import EstruturaController from '@/assets/ts/controller/EstruturaController';
import Processo from '@/assets/ts/interfaces/Processo';
import ProcessoController from '@/assets/ts/controller/ProcessoController';
import CurriculoPopup from '../CurriculoPopup/CurriculoPopup.vue';
import AddCandidatoPopup from '../AddCandidatoPopup/AddCandidatoPopup.vue';
import ToolbarAction from '@/../bower_components/teknisavuecomponents/assets/interfaces/ToolbarAction';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import { ControleAcessoWrapper } from '@/assets/ts/controller/ControleAcessoController';



@Component({
  name: 'FasePopup',
  components: {
    TkForm,
    EditableTable,
    CurriculoPopup,
    AddCandidatoPopup,
  },
})
class FasePopup extends Vue {
  // #region [ PROPS ]
  @Prop({ default: () => {} })
  private readonly row: any;

  @Prop({ default: false })
  private readonly value: boolean;
  // #endregion

  // #region [ EVENTS ]
  @Emit('input')
  private emitInput(value: boolean) {}
  // #endregion

  // #region [ DATA ]
  private readonly DEFAULT_TITLE = 'Fase do Processo';

  private internalValue = false;

  private loading = {
    candidatos: false,
  };

  private lastLoadedNrFase: string = null;

  private curriculoPopup = {
    show: false,
    url: null,
  };

  private addCandidatoPopup = {
    show: false,
    nrProcesso: null as string,
  };

  private candidatos: any[] = [];
  // #endregion

  // #region [ COMPUTED ]
  private get isLoading(): boolean {
    const loadingValues = Object.values(this.loading);
    const internalLoading = Util.oneTrue(...loadingValues);
    return internalLoading;
  }

  private get cardTitle(): string {
    const title = this.row ?
      `${this.DEFAULT_TITLE} - ${this.row.NMFASE}` :
      this.DEFAULT_TITLE;

    return title;
  }

  private get canAddCandidato(): boolean {
    if (!this.row) {
      return false;
    }

    const canAdd = this.row.NRORDEM === '1';
    return canAdd;
  }

  private get addCandidatoColor(): string {
    if (this.canAddCandidato) {
      return 'green';
    }

    return 'orange';
  }

  private get grid() {
    return {
      toolbarActions: [
        {
          name: 'reload',
          label: 'Atualizar',
          icon: 'mdi-refresh',
          onClick: this.loadCandidatosFase,
        },
        {
          name: 'addCandidato',
          label: 'Adicionar Candidato',
          icon: 'mdi-account-plus',
          color: this.addCandidatoColor,
          onClick: ControleAcessoWrapper.criar(this.addCandidatoOnClick),
        }
      ] as ToolbarAction[],
      columns: [
        {
          value: 'NMPRINCIPALPARC',
          text: 'Nome',
        },
        {
          value: 'NRPONTUACAO',
          text: 'Pontuação',
        },
        {
          value: 'NMTIPORESU',
          text: 'Resultado',
        },
        {
          value: 'NRPERCENTUAL',
          text: 'Percentual',
        },
        {
          value: 'NRAVALIACAO',
          text: 'Pontos de Avaliação',
        },
      ] as EditableTableColumn[],
      rows: this.candidatos,
    };
  }
  // #endregion

  // #region [ LIFECYCLE ]
  private created() {
    //
  }
  // #endregion

  // #region [ WATCHERS ]
  @Watch('value', { immediate: true })
  private valueOnChange() {
    this.internalValue = this.value;

    if (this.internalValue) {
      this.scrollToTop();
      this.loadCandidatosFase();
    }
  }
  // #endregion

  // #region [ METHODS ]
  private closeDialog(): void {
    this.internalValue = false;
    this.emitInput(this.internalValue);

    this.lastLoadedNrFase = this.row.NRFASE;
  }

  private async loadCandidatosFase(): Promise<void> {
    const nrProcesso: string = this.row.NRPROCESSO;
    const nrFase: string = this.row.NRFASE;

    this.loading.candidatos = true;
    this.candidatos = [];

    try {
      const candidatos = await ProcessoController.getCandidatosFase(nrProcesso, nrFase, false);

      if (nrProcesso === this.row.NRPROCESSO && nrFase === this.row.NRFASE) {
        this.candidatos = candidatos;
      }
    } finally {
      this.loading.candidatos = false;
    }
  }

  private rowOnClick(candidato: any): void {
    this.gerarCurriuloCandidato(candidato);
  }

  private async gerarCurriuloCandidato(candidato: any): Promise<void> {
    const nrOrg = candidato.NRORG_CAND;
    const nrParcNegocio = candidato.NRPARCNEGOCIO;

    const link = await ProcessoController.generateResume(
      nrOrg, nrParcNegocio
    );

    this.curriculoPopup.show = true;
    this.curriculoPopup.url = link;
  }

  private addCandidatoOnClick(): void {
    if (this.canAddCandidato) {
      this.openAddCandidatoPopup();
    } else {
      const message = 'Só é possível adicionar candidatos à 1ª fase do processo!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ALERT);
    }
  }

  private openAddCandidatoPopup(): void {
    this.addCandidatoPopup.show = true;
    this.addCandidatoPopup.nrProcesso = this.row.NRPROCESSO;
  }

  private scrollToTop(): void {
    const contentDivElement = this.$refs.content as Element;

    if (!contentDivElement) {
      return;
    }

    contentDivElement.scrollTop = 0;
  }

  private onAfterAddCandidato(): void {
    this.loadCandidatosFase();
  }
  // #endregion
}

export default FasePopup;
